import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import ShadowBlock from '../../../../atoms/ShadowBlock';
import Table from '../../../../atoms/Table/Table';
import EmptyBlock from '../../../../molecules/EmptyBlock';
import { apiClient } from '../../../../../lib/apiClient';
import notificationUtils from '../../../../../utils/notificationUtils';
import { resolvedProblemsTableColumns } from './ResolvedProblems.constants';
import LoaderCover from '../../../../atoms/LoaderCover';
import Field from '../../../../atoms/Field';
import SearchInputWithLabel from '../../../../atoms/SearchInputWithLabel/SearchInputWithLabel';
import MButton from '../../../../MUI/Button/MButton';
import Form from '../../../../atoms/Form';
import Dropdown from '../../../../atoms/Dropdown';
import { entityOptions } from '../ActiveProblems/ActiveProblems.constants';

export const ResolvedProblems = () => {
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      name: '',
      entity: '',
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [tableLoading, setIsTableLoader] = useState(false);
  const [resolvedProblems, setResolvedProblems] = useState(null);

  const formValues = form.watch();

  const handleFetchDataPage = async (currentPage = 1) => {
    setIsTableLoader(true);

    const params = {
      pageSize: 10,
      currentPage,
      entity: formValues?.entity?.value ?? undefined,
      name: formValues?.name || undefined,
    };

    try {
      const res = await apiClient.post(`/api/quickBooksMappingProblems/filter/fixed`, params);
      setResolvedProblems(res.data.result?.items?.length ? res.data.result : []);
    } catch {
      notificationUtils.error('Failed, try again later');
    } finally {
      setIsTableLoader(false);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      handleFetchDataPage();
    } catch (e) {
      notificationUtils.error('Unknown record name');
      setResolvedProblems(null);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    handleFetchDataPage();
  }, []);

  return (
    <Stack>
      <Form form={form} onSubmit={handleSubmit}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap">
          <Stack direction="row" gap={3} alignItems="center">
            <Field
              name="name"
              render={({ field, onCustomChange }) => (
                <SearchInputWithLabel
                  label="Record Name"
                  placeholder="Enter record name"
                  onChangeValue={onCustomChange(field.onChange)}
                  name="name"
                  value={field.value}
                  width={300}
                />
              )}
            />
            <Field
              name="entity"
              render={({ field, onCustomChange }) => {
                return (
                  <Dropdown
                    value={field.value}
                    isColumn
                    width="250px"
                    placeholder="Select entity type"
                    options={entityOptions}
                    onChange={onCustomChange(field.onChange)}
                    height="44px"
                    isClearable
                  />
                );
              }}
            />
            <MButton data-testid="apply_btn" size="medium" variant="secondary" type="submit">
              Apply
            </MButton>
          </Stack>
        </Stack>
      </Form>
      {isLoading && <LoaderCover />}
      {resolvedProblems && !isLoading && (
        <Box width="100%" margin="0 auto" mt={2}>
          <ShadowBlock>
            <Stack position="relative">
              {resolvedProblems?.items?.length ? (
                <Box
                  height={isLoading ? '850px' : 'auto'}
                  display="flex"
                  alignItems="center"
                  pb={4}
                >
                  <Table
                    columns={resolvedProblemsTableColumns}
                    rows={resolvedProblems.items ?? []}
                    total={resolvedProblems?.totalRowsCount}
                    isPagination={resolvedProblems?.totalPages > 1}
                    onNextPage={handleFetchDataPage}
                    onPreviousPage={handleFetchDataPage}
                    onGotoPage={handleFetchDataPage}
                    onRefreshPage={handleFetchDataPage}
                    pageSize={10}
                    loading={tableLoading}
                    overflowHidden={false}
                  />
                </Box>
              ) : (
                <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                  <EmptyBlock title="No Records" />
                </Box>
              )}
            </Stack>
          </ShadowBlock>
        </Box>
      )}
    </Stack>
  );
};
